$(document).ready(function () {
  const btns = $(".nav-link");

  const contents = $(".how-to__card");
  btns.click(function (e) {
    const target = $(this);

    function showHide(targetClass) {
      contents.each(function () {
        if (!$(this).hasClass(targetClass)) {
          $(this).css("opacity", "0");

          setTimeout(() => {
            $(this).css("display", "none");
          }, 300);
        } else {
            $(this).css("opacity", "1");
            setTimeout(() => {
                $(this).css("display", "block");
              }, 300);
            
        }
      });
    }

    if (target.attr("id") === "outdoor-tab") {
      showHide("outdoor-content");
    } else if (target.attr("id") === "wellness-tab") {
      showHide("wellness-content");
    } else if (target.attr("id") === "respiratoryxAllergy-tab") {
      showHide("respiratoryxAllergy-content");
    } else {
      contents.each(function () {
          $(this).css("display", "block");
          $(this).css("opacity", "1");
          
      });
    }
  });

  
      // // Video Modal
      // $('.collapse').on('show.bs.collapse', function (e) {
        
      //   let $triggerButton = $('[data-target="#' + $(this).attr('id') + '"]');
      //   let videoUrl = $triggerButton.attr('data-video-url');

      //   if (videoUrl) {
      //     e.preventDefault();
      //     $triggerButton.addClass('collapsed').attr('aria-expanded', 'false');

      //     $('#youtubeIframe').attr('src', videoUrl);

      //     $('#productVideoModal').modal('show');
      //   }
      // });

      // $('#productVideoModal').on('hidden.bs.modal', function () {
      //   $('#youtubeIframe').attr('src', '');
      // });

});


const tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
const firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

let ytPlayers = [];

window.onYouTubeIframeAPIReady = function() {
  const iframes = document.querySelectorAll(".how-to__video-media");

  iframes.forEach((iframe, index) => {
    if (!iframe.id) {
      iframe.id = `how-to-yt-player-${index}`;
    }

    const player = new YT.Player(iframe.id, {
      events: {
        'onStateChange': (event) => {
          if (event.data === YT.PlayerState.PLAYING) {
            ytPlayers.forEach(p => {
              if (p !== player && p.getPlayerState && p.getPlayerState() === YT.PlayerState.PLAYING) {
                p.pauseVideo();
              }
            });
          }
        }
      }
    });
    
    ytPlayers.push(player);
  });
};